import apis from '@/api/apis_moudles'
const state = {
  apiCount: 0,
  loading: false,
  employeeList: [], // 会员列表
  edit: true, // 预授权编辑与否
  claimStep: '1', // 理赔申请步骤
  claimEdit: true, // 理赔申请编辑与否
  step: '1', // 预授权步骤
  nextP: true, //是否展示上传的下一页按钮
  nopay: 1, //保单管理
  memberNo: '', //添加银行卡时被保人会员id
  appoint: false, // 预约
  showPreUpload: false, //进入预授权申请时，是否展示上传组件
  showCliUpload: false //进入理赔申请时，是否展示上传组件
}
const getters = {
  employeeList(state) {
    return state.employeeList
  },
  apiCount(state) {
    return state.apiCount
  }
}
const mutations = {
  setApiCount(state, handle) {
    if (handle == 'add') {
      state.apiCount++
      state.loading = true
    } else {
      state.apiCount--
      if (state.apiCount <= 0) {
        state.loading = false
      }
    }
  },
  setEmployeeList(state, data) {
    state.employeeList = data
  },
  setEdit(state, str) {
    state.edit = str
  },
  setClaimStep(state, str) {
    state.claimStep = str
  },
  setClaimEdit(state, str) {
    state.claimEdit = str
  },
  setStep(state, str) {
    state.step = str
  },
  setNextP(state, str) {
    state.nextP = str
  },
  setNopay(state, str) {
    state.nopay = str
  },
  setMemberNo(state, str) {
    state.memberNo = str
  },
  setPreUpload(state, str) {
    state.showPreUpload = str
  },
  setappoint(state, str) {
    state.appoint = str
  },
  setCliUpload(state, str) {
    state.showCliUpload = str
  }
}

const actions = {
  // 页面加载动画
  /* 更新请求线程池 */
  updateApiCount(context, handle) {
    context.commit('setApiCount', handle)
  },
  // 获取最新会员信息
  updateEmployeeInfo(context, params) {
    apis.showEmployeeInfo(params).then((res) => {
      const { data } = res.data
      context.commit('setEmployeeList', data || [])
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
